import { useBackend } from "../../services";
import { ImageCache } from "../../models/ImageCache";
import { StatusCodes } from "http-status-codes";
import { StatusCodesHelper } from "../../models/StatusCodesHelper";

export const useGetImageSignedUrl = () => {
  const { get } = useBackend();
  const getImageSignedUrl = async (name: string) => {
    const cachedImage = await ImageCache.shared.getCachedImage(name);
    if (cachedImage) {
      return { status: StatusCodes.OK, body: cachedImage };
    } else {
      const { status, body } = await get("images/signedUrl", { name });
      if (StatusCodesHelper.isSuccessful(status)) {
        await ImageCache.shared.saveImage(name, body);
      }
      return { status, body };
    }
  };
  return { getImageSignedUrl };
};
